/* Jquery */
var $ = require("jquery");

import { auto } from "@popperjs/core";
/* Swiper */
import Swiper from "swiper";

function swiperCarousel() {

  const carruseles = document.querySelectorAll(".carousel__item");
  
  console.log( 'HOLA' , carruseles );

  $.each(carruseles, function () {

    const Item = $(this).find(".swiper-container");
    const nextBtn = $(this).find(".swiper-button-next");
    const prevBtn = $(this).find(".swiper-button-prev");

    const swiper = new Swiper(Item, {
      autoResize: false,
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        768: {
          spaceBetween: 15,
          // slidesPerView: iPadCol,
          // spaceBetween: 15,
        },
      }
    });

  });
}

export default swiperCarousel;
